import type { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import { formatNumber } from '~/utils/common';

import type { TypeReceiveReportHistoryDetail } from '~/types/receive.types';

type TypeReportDetailTask = TypeReceiveReportHistoryDetail['tasks'][number];

/**
 * [입고관리 > 입고 리포트 상세] 리포트 발행 항목 테이블
 */
const getReceiveReportDetailTasksColumnDefs = ({
  onClickViewIssueImages,
}: {
  onClickViewIssueImages: (data: TypeReportDetailTask) => void;
}) => {
  const columnDefs: ColDef<TypeReportDetailTask>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'taskName',
      headerName: '작업 유형',
      width: 160,
    },
    {
      field: 'goodsCode',
      headerName: '상품코드',
      width: 200,
    },
    {
      field: 'goodsName',
      headerName: '상품명',
      width: 240,
    },
    {
      field: 'images',
      headerName: '이슈 이미지',
      width: 92,
      minWidth: 92,
      cellRenderer: TextButtonCell,
      cellRendererParams: ({ data }: ICellRendererParams<TypeReportDetailTask>) => ({
        children: '보기',
        onClick: () => {
          if (!data) return;
          onClickViewIssueImages(data);
        },
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'sku',
      headerName: '리포트 SKU',
      width: 100,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeReportDetailTask, TypeReportDetailTask['sku']>) =>
        value ? formatNumber(value) : '-',
    },
    {
      field: 'unit',
      headerName: '리포트 Unit',
      width: 100,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeReportDetailTask, TypeReportDetailTask['unit']>) =>
        value ? formatNumber(value) : '-',
    },
    {
      field: 'taskUnit',
      headerName: '부가작업처리수량',
      width: 122,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeReportDetailTask, TypeReportDetailTask['taskUnit']>) =>
        value ? formatNumber(value) : '-',
    },
    {
      field: 'taskMeasure',
      headerName: '작업단위',
      width: 100,
    },
  ];

  return { columnDefs };
};

export default getReceiveReportDetailTasksColumnDefs;
